AoPS.Utils.initKeyChain(AoPS, "Ebooks", "BookController");

AoPS.Ebooks.BookController = (function () {
	// Dependencies
	var Utils = AoPS.Utils;

	var EbkUrl = AoPS.Ebooks.Url;
	var EbkVBook = AoPS.Ebooks.Views.Book;

	return Utils.Class.extend(
		_.extend({}, Backbone.Events, {
			initialize: function (options) {
				var book = options.book_model;
				this.book_model = book;

				this.url_table = EbkUrl.createBookTable({
					root_url: options.root_url,
					book_id: book.id,
				});

				this.view = new EbkVBook.Main({
					model: book,
					url_table: this.url_table,
					stay_attr: options.stay_attr || "data-ebk-stay",
					full: options.full,
				});
			},

			getCurrentUrl: function () {
				if (this.current_section_id) {
					return this.getUrl(this.current_section_id);
				}
			},

			getUrl: function (section_id, details) {
				var book = this.book_model;
				details = details || {};
				section_id = book.getAsSectionId(section_id);

				var section = book.get("sections").get(section_id);
				if (!section) {
					return;
				}

				var section_code = section.get("fragment_code");
				if (details.label_id) {
					return this.url_table.getUrlWithoutRoot(
						"section_label",
						section_code,
						details.label_id
					);
				} else if (details.paragraph_id) {
					return this.url_table.getUrlWithoutRoot(
						"section_paragraph",
						section_code,
						details.paragraph_id
					);
				} else if (details.problem_id) {
					return this.url_table.getUrlWithoutRoot(
						"section_problem",
						section_code,
						details.problem_id
					);
				} else {
					return this.url_table.getUrlWithoutRoot("section", section_code);
				}
			},

			processUrl: function (url, details) {
				url = url || "";
				var match = this.url_table.matchUrl(url, true);
				if (!match) {
					// Try to match one more time if the URL had a trailing slash.
					if (url && url.slice(-1) === "/") {
						match = this.url_table.matchUrl(url.slice(0, -1), true);
					}
					if (!match) {
						// Okay, now we can give up.
						this.handleError("The URL " + url + " was not recognized.");
						return;
					}
				}

				this.book_model.requestLoad(function (ok, data) {
					if (!ok) {
						return this.handleError(
							"Book " + this.book_model.id + " failed to load.",
							data
						);
					}

					// Compute the fragment ID from the URL
					var fragment_id = this.book_model.getFragmentIdFromCode(match[1]);
					// Clone details so that we can modify it without causing side effects.
					details = _.clone(details) || {};

					// Branch based on which URL we got.
					if (match[0] === "index") {
						this.showSection(null, details);
					} else if (match[0] === "last") {
						this.redirectToSection(
							this.book_model.get("last_viewed_section_id"),
							details
						);
					} else if (match[0] === "section") {
						this.showSection(fragment_id, details);
					} else if (match[0] === "section_label") {
						details.label_id = match[2];
						this.showSection(fragment_id, details);
					} else if (match[0] === "section_paragraph") {
						details.paragraph_id = match[2];
						this.showSection(fragment_id, details);
					} else if (match[0] === "section_problem") {
						details.problem_id = match[2];
						this.showSection(fragment_id, details);
					} else if (match[0] === "label") {
						this.findAndShowLabel(match[1], details);
					} else if (match[0] === "paragraph") {
						this.findAndShowParagraph(match[1], details);
					} else if (match[0] === "problem") {
						this.findAndShowProblem(match[1], details);
					}
				}, this);
			},

			// Call this when you need the URL bar to be updated to the currently
			// shown Ebook section.
			resyncUrlBar: function (url) {
				url = url || this.getCurrentUrl();
				// HACK: some kind of ridiculous ordering constraint in the grid where
				// this event tries to set breadcrumbs before the router is ready.
				// Therefore, we delay a little with setTimeout.
				if (url) {
					setTimeout(
						_.bind(function () {
							this.trigger("replace_url", url);
						}, this),
						0
					);
				}
			},

			// Private helper functions follow. Do not use in your code.
			// All of the below functions may assume the book has been loaded.

			// details is one of:
			// {label_id: ...}
			// {paragraph_id: ...}
			// {problem_id: ...}
			// {search: ...}
			// {paragraph_id: ..., search: ...}
			showSection: function (section_id, details) {
				var book = this.book_model;
				var chapter = book.get("chapters").get(section_id);
				var section = book.get("sections").get(section_id);

				if (section) {
					this.current_section_id = section_id;
					this.view.showSection(section, details);
					this.trigger("show_section", section, details);
					this.triggerBreadcrumbsUpdate(section, details);
				} else if (chapter) {
					this.redirectToSection(chapter.getFirstSectionId(), details);
				} else {
					this.redirectToSection(book.getFirstSectionId(), details);
				}
			},

			findAndShowLabel: function (label_id, details) {
				if (!this.book_model.get("has_access")) {
					this.trigger("force_out_of_book");
					return;
				}

				this.book_model.findLabel(
					label_id,
					function (ok, data) {
						if (!ok) {
							return this.handleError(
								"The link you provided in the URL is not valid in this book.",
								data
							);
						}
						var section_id = data;
						this.redirectToSection(
							section_id,
							_.extend({label_id: label_id}, details)
						);
					},
					this
				);
			},

			findAndShowParagraph: function (paragraph_id, details) {
				if (!this.book_model.get("has_access")) {
					this.trigger("force_out_of_book");
					return;
				}

				this.book_model.findParagraph(
					paragraph_id,
					function (ok, data) {
						if (!ok) {
							return this.handleError(
								"Paragraph " + paragraph_id + " could not be found.",
								data
							);
						}
						var section_id = data;
						this.redirectToSection(
							section_id,
							_.extend({paragraph_id: paragraph_id}, details)
						);
					},
					this
				);
			},

			findAndShowProblem: function (problem_id, details) {
				if (!this.book_model.get("has_access")) {
					this.trigger("force_out_of_book");
					return;
				}

				this.book_model.findProblem(
					problem_id,
					function (ok, data) {
						if (!ok) {
							return this.handleError(
								"Problem " + problem_id + " could not be found.",
								data
							);
						}
						var section_id = data;
						this.redirectToSection(
							section_id,
							_.extend({problem_id: problem_id}, details)
						);
					},
					this
				);
			},

			triggerBreadcrumbsUpdate: function (section, details) {
				var book = this.book_model;
				var chapter = section.get("chapter");
				var section_code = book.getFragmentCodeFromId(
					chapter.getFirstSectionId()
				);
				this.trigger("breadcrumbs", [
					{
						text: chapter.getNumberTitle({plain: true}),
						url: this.url_table.getUrl("section", section_code),
					},
					{text: section.getNumberTitle({plain: true})},
				]);
			},

			// Navigate to the URL given by the section ID. Third parameter is
			// an object with paragraph_id/label_id/problem_id/search keys,
			// which augment the URL appropriately and do some scrolling when the
			// section is rendered.
			redirectToSection: function (section_id, details) {
				var book = this.book_model;
				section_id = section_id || book.getFirstSectionId();

				var url = this.getUrl(section_id, details);
				if (!url && !book.get("has_access")) {
					this.trigger("force_out_of_book");
					return;
				}
				if (!url) {
					this.handleError(
						"Attempted to go to section " + section_id + " which was not found."
					);
					return;
				}

				this.trigger("replace_url", url);
				this.processUrl(url, details);
			},

			// data is optional
			handleError: function (message, data) {
				delete this.current_section;
				console.log(message, data);
				this.view.whenRendered(function () {
					this.view.showError(message);
				}, this);
			},
		})
	);
})();
